import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'nuts_token';

const NutsAuthContext = createContext(null);

export const NutsAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, restore session from token
  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API_URL}/api/nuts/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMember(r.data))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const persistSession = (token, m) => {
    localStorage.setItem(TOKEN_KEY, token);
    setMember(m);
  };

  const register = async (payload) => {
    const { data } = await axios.post(`${API_URL}/api/nuts/register`, payload);
    persistSession(data.access_token, data.member);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API_URL}/api/nuts/login`, { email, password });
    persistSession(data.access_token, data.member);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setMember(null);
  };

  const getToken = () => localStorage.getItem(TOKEN_KEY);

  const refreshMember = async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    try {
      const r = await axios.get(`${API_URL}/api/nuts/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMember(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  return (
    <NutsAuthContext.Provider value={{ member, loading, register, login, logout, getToken, refreshMember }}>
      {children}
    </NutsAuthContext.Provider>
  );
};

export const useNutsAuth = () => {
  const ctx = useContext(NutsAuthContext);
  if (!ctx) throw new Error('useNutsAuth must be used inside NutsAuthProvider');
  return ctx;
};
